import React, {useContext, useEffect, useState} from "react";
import LinearProgress from "@mui/material/LinearProgress";
import {withBasicProviders} from "../provider/withBasicProviders";
import useTree from "../hooks/useTree";
import Mermaid from "../components/Mermaid";
import Box from "@mui/material/Box";
import Header from "../components/Header";
import AuthProvider, {authContext} from "../provider/AuthProvider";

let checkRelation = {};
let checkInfo = {};
function Flow(props) {
  const {tree, errors} = useTree();
  const {authed} = useContext(authContext);

  function renderMapping(parent, node) {
    function pairing(parent, node) {
      function one(node) {
        return node?.id;
      }
      const relation = `${one(parent)}-->${one(node)}`;
      if (checkRelation[relation]) {
        return "";
      }
      checkRelation[relation] = true;
      return relation;
    }

    if (!node?.id) {
      console.log("null");
      return null;
    }

    if (!Array.isArray(node.children)) {
      return pairing(parent, node);
    }

    return `${pairing(parent, node)}\n${node.children
      .map((entry) => renderMapping(node, entry))
      .join("")}`;
  }

  function renderInfo(node) {
    function url(node) {
      return `https://app.contentful.com/spaces/${process.env.CONTENTFUL_SPACE}/entries/${node?.id}`;
    }

    function info(node) {
      return `
      ${node?.id}("»${node?.name}<br>(${node?.inquiryCategory || ""})")
      click ${node?.id} "${url(node)}" "${tooltip(node)}"
      class ${node?.id} ${node?.inquiryType}
      `;
    }

    function tooltip(node) {
      const questions = node?.questions;
      if (!questions) {
        return "no questions";
      }
      return questions
        ?.map(
          (question) =>
            `» ${question.title.replace(
              '"',
              "&#34;"
            )} (${question?.inquiryCategory?.replace('"', "&#34;")}) `
        )
        .join("");
    }

    if (!node?.id) {
      return "";
    }
    if (checkInfo[node?.id]) {
      return "";
    }

    checkInfo[node?.id] = true;
    if (!Array.isArray(node.children)) {
      return info(node);
    }

    return `${info(node)}\n${node.children
      .map((entry) => renderInfo(entry))
      .join("")}`;
  }

  if (!authed) {
    return null;
  }
  if (!tree?.children) {
    return <LinearProgress />;
  }

  const mapping = `flowchart LR
    ${renderMapping(null, tree)}
    ${renderInfo(tree)}

    classDef question font-weight: 900;
    classDef answer font-weight: 100;
    classDef undefined font-weight: 500;
    `;

  console.log(mapping);
  console.log(tree);
  console.log(errors);

  return (
    <>
      <Header />
      <Box marginTop={10}>
        <Mermaid chart={mapping} />
      </Box>
    </>
  );
}
export default withBasicProviders(AuthProvider)(Flow);
